import React from "react";
import { Input, Form } from "antd";
import { EyeTwoTone, EyeInvisibleOutlined } from "@ant-design/icons";

export const FormInputItem = ({
  name,
  placeholder,
  icon,
  rules = [],
  type = "text",
  label,
  normalize,
  onKeyDown,
  validateStatus,
  hasFeedback,
  help
}) => (
  <Form.Item
    name={name}
    normalize={normalize}
    rules={rules}
    label={label}
    help={help}
    validateStatus={validateStatus}
    hasFeedback={hasFeedback}
  >
    <Input
      type={type}
      placeholder={placeholder}
      autoComplete="off"
      prefix={
        icon
          ? React.cloneElement(icon, { style: { marginRight: "8px" } })
          : null
      }
      onKeyDown={onKeyDown}
    />
  </Form.Item>
);

export const FormPasswordItem = ({
  name,
  placeholder,
  icon,
  rules = [],
  help,
  validateStatus,
  hasFeedback,
  label,
}) => (
  <Form.Item
    name={name}
    rules={rules}
    help={help}
    validateStatus={validateStatus}
    hasFeedback={hasFeedback}
    label={label}
  >
    <Input.Password
      placeholder={placeholder}
      prefix={
        icon
          ? React.cloneElement(icon, { style: { marginRight: "8px" } })
          : null
      }
      iconRender={(visible) =>
        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
      }
      style={validateStatus === "warning" ? { borderColor: "#faad14" } : {}}
    />
  </Form.Item>
);
